<div class="card-body position-relative overflow-hidden">
  <div class="font-size-36 font-weight-bold text-dark mb-n2">{{registeredAdapters}}</div>
  <div class="text-uppercase">Registered Adapters</div>
  <div class="chartContainer">
  </div>
</div>